export const POST_FILTERS = [
  { value: 'all', label: 'Tous', keep: () => true },
  { value: 'rows', label: 'Avec topics', keep: (p) => p.rows > 0 },
  { value: 'proposals', label: 'Propositions', keep: (p) => p.proposals > 0 },
  { value: 'empty', label: 'Vides', keep: (p) => p.rows === 0 },
];

export const filterPosts = (posts, { filter, topic, query }) => {
  const { keep } = POST_FILTERS.find((f) => f.value === filter);
  const q = query.trim().toLowerCase();
  return posts.filter((p) => keep(p)
    && (!topic || p.topics.includes(topic))
    && (!q || [p.excerpt, p.visit_key, p.channel, ...p.topics].some((v) => v?.toLowerCase().includes(q))));
};

export const topicCounts = (posts) => {
  const byCode = new Map();
  for (const p of posts) for (const code of p.topics) byCode.set(code, (byCode.get(code) || 0) + 1);
  return [...byCode.entries()].sort((a, b) => b[1] - a[1]);
};

export const groupByVisit = (rows) => rows.reduce((visits, row) => {
  const last = visits[visits.length - 1];
  if (last?.rank === row.visit_rank) last.rows.push(row);
  else visits.push({ rank: row.visit_rank, rows: [row] });
  return visits;
}, []);

export const compareBy = (key, direction) => (a, b) => {
  const va = a[key];
  const vb = b[key];
  if (va === vb) return 0;
  if (va == null) return 1;
  if (vb == null) return -1;
  const order = typeof va === 'string' ? va.localeCompare(vb) : va - vb;
  return direction === 'asc' ? order : -order;
};
